import { render, staticRenderFns } from "./Col8.vue?vue&type=template&id=0857903a&scoped=true"
import script from "./Col8.vue?vue&type=script&lang=js"
export * from "./Col8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857903a",
  null
  
)

export default component.exports